<template>
  <div
    id="chr-incidents"
    class="tw-flex tw-flex-col tw-items-start tw-gap-[40px] tw-self-stretch tw-bg-[#ffffff]"
  >
    <div class="tw-flex tw-flex-col tw-gap-[16px] !tw-break-inside-avoid">
      <div class="tw-flex tw-justify-between tw-w-[100%]">
        <div class="tw-flex tw-items-center">
          <span
            id="chr-sheading-incidents"
            class="tw-text-[#211F58] tw-text-[24px] tw-font-semibold tw-w-fit"
          >
            {{
              getComponentUiText(
                "app-share-cyber-profile-incidents-and-events-title-1",
              )
            }}
          </span>
        </div>

        <div class="tw-flex tw-items-center tw-gap-5">
          <div
            v-if="isEdit"
            class="tw-rounded-full tw-bg-[#387DFF] tw-w-[28px] tw-h-[28px] tw-flex tw-justify-center tw-items-center tw-cursor-pointer"
            @click="addNew"
          >
            <img
              class="tw-w-[12px] tw-h-6"
              src="@/assets/img/plus-icon.svg"
              alt="sub"
            />
          </div>

          <div
            id="pen-icon-incidents"
            :class="[
              isEdit ? 'is_editable' : 'not_editable',
              isCallApi
                ? '!tw-cursor-not-allowed !tw-bg-[#211F58] !tw-p-[5px]'
                : '',
            ]"
            class="header__pen tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
            @click="editNotes"
          >
            <Pen
              :is-call-api="isCallApi"
              :color="isEdit ? '#ffffff' : '#387DFF'"
            />
          </div>
        </div>
      </div>
      <div
        class="tw-text-[#231F20] tw-text-[14px] tw-font-normal xl:tw-w-[50%] tw-opacity-[0.7]"
      >
        {{
          getComponentUiText(
            "app-rshare-cyber-profile-incidents-and-events-sub-title-1",
          )
        }}
      </div>
    </div>
    <IncidentsAndEventsTable
      :is-loading="isLoading"
      :is-show-edit="isEdit"
      :data="customTableData"
      :is-edit="isEdit"
      :is-discard="isDiscard"
      @call-api="isCallApi = $event"
    />
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { computed, Ref, ref, watch } from "vue";
import IncidentsAndEventsTable from "./incidentsAndEventsTable.vue";
import Pen from "@/components/svgs/pen.vue";
import store from "@/store";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
  isDiscard: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:edit"]);
const isCallApi: Ref<boolean> = ref(false);

const customTableData: Ref<any> = computed(() => {
  return store.getters["Sharing/getChecklistIncidents"];
});

const editNotes = () => {
  emit("update:edit", !props.isEdit);
  if (!isCallApi.value) {
    isCallApi.value = false;
  }
};

// add new data
const addNew = () => {
  eventEmitter.emit(EmitterEvents.SHARING_ADD_INCIDENT);
};
</script>

<style lang="scss" scoped>
.header__pen {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  padding: 9px 14px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  width: 46px;
  height: 44px;
}

.is_editable {
  cursor: pointer;
  background: var(--Brand-Navy, #211f58);
}

.not_editable {
  cursor: pointer;
  background: var(--UI-white, #fff);
}

@media print {
  :deep(.table-header) {
    background-color: #211f58 !important;
  }
  #pen-icon-incidents {
    display: none;
  }
}
</style>
